module.exports = __webpack_public_path__ + "assets/img/cheap@2x.622c4820.png";